import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/cross.svg";
var CrossSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CrossSolid_default as default
};
